import { SERVER } from "../../common/config/utils";

export const UPLOAD_IMAGE = "/learn/upload-image.svg";
export const OG_IMAGE = `${SERVER}/community/og-image.png`;

export const SUBMISSION_POLL_LIMIT = 10;
// Polling interval for submission in ms
export const SUBMISSION_POLL_INTERVAL = 2000;

export const TEACHING_ASSISTANT_FEEDBACK_FORM =
  "https://docs.google.com/forms/d/1tQonLIU-5ZkfBOKa-3F8iHrlXi9uETzyalCePjYUyLE/edit";

export const JUPITER_AVATAR = "/learn/teaching-assistant/avatar.svg";

export const INTERVAL = 1000;
export const FILE_IMAGE = "/learn/file.svg";
export const RIGHT_TICK_IMAGE = "/learn/right-tick.svg";
export const REACH_OUT_US_URL =
  "https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=support@aiplanet.com";
